export default __webpack_public_path__ + "static/media/csvDownload.73655b60.png";